module.exports = __webpack_public_path__ + "img/Group 97848.809ded2f.png";